import React, { useEffect } from "react";
import { connect } from "react-redux";
import MaintenanceDashboard from "../../components/maintenance/MaintenanceDashboard";
import {
  fetchDashboard,
  fetchDashboardSuccess,
  fetchDashboardFailure,
  fetchUpcomingMaintenance,
  fetchUpcomingMaintenanceSuccess,
  fetchUpcomingMaintenanceFailure,
  fetchOverdueMaintenance,
  fetchOverdueMaintenanceSuccess,
  fetchOverdueMaintenanceFailure,
} from "../../store/maintenance/actions";

const MaintenanceDashboardContainer = ({
  dashboard,
  fetchDashboard,
  fetchUpcomingMaintenance,
  fetchOverdueMaintenance,
}) => {
  useEffect(() => {
    fetchDashboard();
    fetchUpcomingMaintenance(30);
    fetchOverdueMaintenance();
  }, [fetchDashboard, fetchUpcomingMaintenance, fetchOverdueMaintenance]);

  return (
    <MaintenanceDashboard
      stats={dashboard.stats}
      upcoming={dashboard.upcoming}
      overdue={dashboard.overdue}
      loading={dashboard.loading}
      error={dashboard.error}
    />
  );
};

const mapStateToProps = (state) => ({
  dashboard: state.maintenance.dashboard,
});

const mapDispatchToProps = (dispatch) => ({
  fetchDashboard: () => {
    dispatch(fetchDashboard()).payload.then(
      (response) => {
        dispatch(fetchDashboardSuccess(response.data));
      },
      (error) => {
        dispatch(fetchDashboardFailure(error.response?.data || error));
      }
    );
  },
  fetchUpcomingMaintenance: (days) => {
    dispatch(fetchUpcomingMaintenance(days)).payload.then(
      (response) => {
        dispatch(fetchUpcomingMaintenanceSuccess(response.data));
      },
      (error) => {
        dispatch(fetchUpcomingMaintenanceFailure(error.response?.data || error));
      }
    );
  },
  fetchOverdueMaintenance: () => {
    dispatch(fetchOverdueMaintenance()).payload.then(
      (response) => {
        dispatch(fetchOverdueMaintenanceSuccess(response.data));
      },
      (error) => {
        dispatch(fetchOverdueMaintenanceFailure(error.response?.data || error));
      }
    );
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(MaintenanceDashboardContainer);
